import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StudentRoutingModule } from './student-routing.module';
import { StudentLayoutComponent } from './student-layout/student-layout.component';
import { ChatComponent } from './chat/chat.component';
import { ProfileComponent } from './profile/profile.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NotesSidebarComponent } from './notes-sidebar/notes-sidebar.component';
import { LucideAngularModule, Book, Plus, MoreHorizontal, Bold, Italic, Underline, List, ListOrdered, FileStack, ClipboardPlus } from 'lucide-angular';

@NgModule({
  declarations: [
    StudentLayoutComponent,
    ChatComponent,
    ProfileComponent,
    SidebarComponent,
    NotesSidebarComponent
  ],
  imports: [
    CommonModule,
    StudentRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    NgbModule,
    LucideAngularModule.pick({ Book, Plus, MoreHorizontal, Bold, Italic, Underline, List, ListOrdered, FileStack, ClipboardPlus })
  ],
  exports: [
    ChatComponent,
    ProfileComponent,
    StudentLayoutComponent
  ]
})
export class StudentModule { }
